import * as React from 'react';
import { Col } from 'react-bootstrap';

import { Button } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

interface OwnProps {
	redirectToFieldReport: () => void;
	redirectToWorkOrder: () => void;
	redirectToJob: (jobId: number) => void;
	jobId: number;
}

type Props = OwnProps;

const WorkOrderLinks: React.FC<Props> = (props) => {

	const {
		redirectToFieldReport,
		redirectToWorkOrder,
		redirectToJob,
		jobId,
	} = props;

	const jobRedirect = React.useCallback(() => {
		redirectToJob(jobId);
	}, [redirectToJob, jobId]);

	return (
		<Col className={styles['originals-container']} sm={3}>
			<Button
				icon="ActionExternal"
				label="Original Field Report"
				onClick={redirectToFieldReport}
				style="link"
			/>
			<Button
				icon="ActionSearch"
				label="Original Work Order"
				onClick={redirectToWorkOrder}
				style="link"
			/>
			<Button
				icon="ActionExternal"
				label="View Job"
				onClick={jobRedirect}
				style="link"
			/>
		</Col>
	);
};

export default React.memo(WorkOrderLinks);
